<template>
  <el-dialog
    title="确定将此句打回任务池？"
    :visible="visible"
    :close-on-click-modal="false"
    @close="close"
  >
    <div class="c-999 h-l-24">
      {{ tips }}
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="singleReturn">确认</el-button>
      <el-button type="primary" @click="close" plain>取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { returnQcTask } from '@/api/qc/qcflow';

export default {
  props: ['visible', 'isReturnPe', 'userInfo', 'row', 'qcTaskId'],
  computed: {
    tips() {
      return this.isReturnPe
        ? '此句将会回到PE碎片池，与其他被打回的句子重新组合后，推送给新的PE译员进行翻译。'
        : '此句将会回到审核任务碎片池，与其他被打回的句子重新组合后到达审核终审环节，由审核修改后重新提交质控。';
    },
  },
  methods: {
    singleReturn() {
      returnQcTask({
        trId: this.row?.lastAuditerId,
        operateQcTaskId: this.qcTaskId,
        qcTaskId: this.row?.qcTaskId,
        operateQcId: this.userInfo?.staffId,
        packageNo: this.row?.pePackageNo,
        sentId: this.row?.id,
      }).then(() => {
        this.close();
        // 单个打回后，需要调父组件的方法，不刷新数据，直接修改当前的选中row
        this.$emit('return-task-pool-done');
      });
    },
    close() {
      this.$emit('update:visible', false);
    },
  },
};
</script>
